import React from "react";
import styled from "styled-components/macro";
import { colors } from "theme/Theme";

interface BottomBarItemProps {
  children: any;
}

const BottomBarItem: React.FC<BottomBarItemProps> = ({ children }) => {
  return <BottomBarItemContainer>{children}</BottomBarItemContainer>;
};

const BottomBarItemContainer = styled.button`
  width: 100%;
  height: 100%;
  background-color: ${colors.light_blue};
  display: inline-flex;
  justify-content: center;
  align-items: center;

  &:not(:last-child) {
    border-right: 1px solid #57b1da;
  }
`;
export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;
export default BottomBarItem;
